export const popoverTokens = {
  popover: {
    root: {
      background: '{overlay.popover.background}',
      borderColor: '{overlay.popover.borderColor}',
      color: '{overlay.popover.color}',
      borderRadius: '{borderRadius.sm}',
      shadow: '0px 4px 18px 0px rgba(53, 67, 88, 0.08)',
      gutter: '10px'
    },
    content: {
      padding: '1.5rem'
    }
  }
};

export type PopoverTokens = typeof popoverTokens;
